import { JSX } from "react";

const Stories = ({ children }: { children: JSX.Element }) => {
  return (
    <div className="swiper-slide">
      <div className="swiper">
        <div className="swiper-wrapper">{children}</div>
      </div>
    </div>
  );
};

export default Stories;
